var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oa-approval"},[_c('van-row',{attrs:{"type":"flex"}},[_c('van-col',{attrs:{"span":"8"}},[_c('a',{attrs:{"href":"/form"}},[_c('img',{attrs:{"src":require("../assets/img/icon/icon-06.png"),"alt":""}})]),_c('h4',[_vm._v("申请特批单")])])],1),_c('bottomTabBar',{attrs:{"activeNum":"/listTabA"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }